module.exports = '<svg width="47" height="32" viewBox="0 0 47 32"><path d="M43.636 8.727h-2.909V2.909C40.727 1.3 39.427 0 37.818 0H2.909A2.908 2.908 0 0 0 0 2.909v26.182A2.908 2.908 0 0 0 2.909 32h34.909c1.609 0 2.909-1.3 2.909-2.909v-5.818h2.909c1.609 0 2.909-1.3 2.909-2.909v-8.727c0-1.609-1.3-2.909-2.909-2.909zm-8.727 17.455H5.818V5.818h29.091v20.364z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/battery-empty-2.js
// module id = 1002
// module chunks = 14